<template>
  <div>
    <el-divider></el-divider>
    <div style="padding-top:8px">
      <el-radio-group v-model="unit" @input="change" :size="size">
        <el-radio label="kg">kg</el-radio>
        <el-radio label="m3">m³</el-radio>
      </el-radio-group>
      
    </div>
  </div>
</template>
<script>
export default {
  name:'GasConsumeUinit',
  data(){
    return{
      unit:'kg',
    }
  },
  mounted(){
    this.getUnit();
  },
  computed: {
    size() {
      return this.$store.getters.size;
    },
  },
  methods:{
    change(){
      // console.log(this.unit)
      this.$api.setTemplateConfigApp({
        TemplateType: 2,
        Note:this.unit,
      })
        .then(async (res)=>{
          if(res.code == 200){
            this.$message.success(this.$t("PersonalizedConfig.修改成功，请重新查询相关数据"));
            await this.$store.dispatch("user/setGasUnit",this.unit);
          }else{
            this.$message.warning(this.$t("PersonalizedConfig.保存失败，请重试"));
            this.getUnit();
          }
        })
    },
    getUnit(){
      this.$api.queryTemplateConfigApp({})
        .then((res)=>{
          if(res.code == 200){
            this.unit = res.data.GasUnit;
            if(this.unit == ""){
              this.unit = "kg";
            }
          }
        })
        .catch((e)=>{
          
        })
    },
  }
}
</script>
<style scoped>
input[aria-hidden=true] {
	display: none !important;
}
</style>